if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails && !this.elements.viewer) return;

        this.elements.viewer?.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails?.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            ?.addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });

        if (this.dataset.desktopLayout?.includes('thumbnail') && this.mql.matches) this.removeListSemantic();

        // 1. 订阅变体切换事件（放宽 sectionId 限制，确保全局能正常响应）
        if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
          subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event.data && event.data.variant) {
              this.onVariantChange(event.data.variant);
            }
          });
        }

        // 2. 页面初次加载时自动筛选一次
        window.addEventListener('DOMContentLoaded', () => {
          setTimeout(() => {
            const variantInput = this.closest('.product')?.querySelector('input[name="id"]');
            if (variantInput && variantInput.value) {
              this.onVariantChange({ id: variantInput.value });
            }
          }, 100);
        });
      }

      // 提取核心文件名，忽略尺寸和版本参数
      getCleanFilename(url) {
        if (!url) return '';
        try {
          const cleanUrl = url.split('?')[0];
          const filename = cleanUrl.split('/').pop();
          return filename.replace(/_\d+x\d*/g, '').replace(/_\d+x/g, '');
        } catch (e) {
          return url;
        }
      }

      onVariantChange(variant) {
        if (!variant || !variant.id) return;

        const galleryDataEl = document.querySelector('[id^="VariantGalleries"]');
        if (!galleryDataEl) return;

        try {
          const variantGalleries = JSON.parse(galleryDataEl.textContent || '{}');
          const customImages = variantGalleries[variant.id];

          // 当该变体配置了专属图库时
          if (customImages && customImages.length > 0) {
            const customNames = customImages.map((img) => this.getCleanFilename(img.src));

            // A. 筛选主图和缩略图里的所有图片容器
            this.querySelectorAll('img').forEach((imgEl) => {
              const src = imgEl.getAttribute('src') || imgEl.getAttribute('data-src') || '';
              const filename = this.getCleanFilename(src);
              if (!filename) return;

              const isMatch = customNames.some((targetName) => filename.includes(targetName) || targetName.includes(filename));
              const container = imgEl.closest('.product__media-item, .product__thumb-item, li, [data-target]');

              if (container) {
                if (isMatch) {
                  container.style.display = '';
                  container.classList.remove('is-hidden');
                } else {
                  container.style.display = 'none';
                  container.classList.add('is-hidden');
                }
              }
            });

            // B. 重新设为显示第一张匹配的主图
            const firstVisibleItem = this.querySelector('.product__media-item:not([style*="display: none"])');
            if (firstVisibleItem && firstVisibleItem.dataset.mediaId) {
              this.setActiveMedia(firstVisibleItem.dataset.mediaId, true);
            }
          } else {
            // 未配置专属图库时恢复全显
            this.querySelectorAll('.product__media-item, .product__thumb-item, li, [data-target]').forEach((el) => {
              el.style.display = '';
              el.classList.remove('is-hidden');
            });
          }

          // C. 【新增】动态刷新移动端轮播页码与翻页控件显示状态
          this.updateSliderPagination();

        } catch (e) {
          console.error('Variant gallery filter error:', e);
        }
      }

      // 【新增方法】根据当前可见图片数量重新计算移动端计数器
      updateSliderPagination() {
        const sliderComponent = this.querySelector('slider-component') || this.elements.viewer;
        if (!sliderComponent) return;

        // 1. 只统计可见状态（非 hidden / display !== none）的主图 Slide
        const visibleSlides = Array.from(this.querySelectorAll('.product__media-item')).filter((slide) => {
          const style = window.getComputedStyle(slide);
          return style.display !== 'none' && !slide.classList.contains('is-hidden');
        });

        const visibleCount = visibleSlides.length;

        // 2. 找到计数的 DOM 节点
        const totalEl = sliderComponent.querySelector('.slider-counter--total, .slider-counter-total');
        const currentEl = sliderComponent.querySelector('.slider-counter--current, .slider-counter-current');
        const sliderButtons = sliderComponent.querySelector('.slider-buttons');

        // 3. 更新总数和当前页数
        if (totalEl) totalEl.textContent = visibleCount;
        if (currentEl && visibleCount > 0) currentEl.textContent = '1';

        // 4. 当只有 0 或 1 张图时，自动隐藏移动端底部翻页栏 < 1/1 >，提升精品感
        if (sliderButtons) {
          if (visibleCount <= 1) {
            sliderButtons.style.setProperty('display', 'none', 'important');
          } else {
            sliderButtons.style.removeProperty('display');
          }
        }
      }

      onSlideChanged(event) {
        if (!this.elements.thumbnails) return;
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer?.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer?.querySelector('.product__media-item:not([style*="display: none"])');
        if (!activeMedia) return;

        this.elements.viewer?.querySelectorAll('.product__media-item').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        if (prepend && activeMedia.parentElement) {
          if (activeMedia.parentElement.firstChild !== activeMedia) {
            activeMedia.parentElement.prepend(activeMedia);
          }
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            if (activeThumbnail && activeThumbnail.parentElement && activeThumbnail.parentElement.firstChild !== activeThumbnail) {
              activeThumbnail.parentElement.prepend(activeThumbnail);
            }
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;
        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button')?.setAttribute('aria-current', true);
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer?.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems?.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}